/**
 * Fit copy shared by Configuration and Confirm (TMMAPP-0107, TMMAPP-0131).
 * The old Results / misfit step is the Confirm and Configuration phases of the wizard.
 */
import { Alert, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { ImportFit } from '@/api/imports';
import { useLocale } from '@/i18n/useLocale';
import { fitReasonText } from './fitReasons';

function ReasonList({ reasons }: { reasons: ImportFit['reasons'] }) {
  const { t } = useTranslation();
  const locale = useLocale();
  return (
    <Box component="ul" sx={{ marginBlock: 0.5, paddingInlineStart: 2.5 }}>
      {reasons.map((reason, index) => (
        <Typography key={`${reason.code}-${index}`} component="li" variant="body2">
          {fitReasonText(t, reason, locale)}
        </Typography>
      ))}
    </Box>
  );
}

export function FitReasonsBanner({
  fit,
  lead,
  severity,
}: {
  fit: ImportFit;
  lead: string;
  severity: 'info' | 'warning';
}) {
  return (
    <Alert severity={severity} role="status" aria-live="polite">
      <Typography variant="body2">{lead}</Typography>
      {fit.reasons.length > 0 && <ReasonList reasons={fit.reasons} />}
    </Alert>
  );
}
